import { render, staticRenderFns } from "./AlgorithmView.vue?vue&type=template&id=4c5749c8&"
import script from "./AlgorithmView.vue?vue&type=script&lang=js&"
export * from "./AlgorithmView.vue?vue&type=script&lang=js&"
import style0 from "./AlgorithmView.vue?vue&type=style&index=0&id=4c5749c8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports